import { useEffect, useState } from "react";
import axios from "axios";

export default function BackendTest() {
  const [message, setMessage] = useState("Loading...");

  useEffect(() => {
    axios.get("/api/test") // ✅ no localhost needed
      .then(res => setMessage(res.data.message))
      .catch(err => setMessage("❌ Error: " + err.message));
  }, []);

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Backend Test Page</h2>
      <p>{message}</p>
    </div>
  );
}
